module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.91e79f868ab29479bd44.svg";


//////////////////
// WEBPACK FOOTER
// /Users/dani/apps/WebTerminalEN/src/assets/Theme/fonts/glyphicons-halflings-regular.svg
// module id = ../../../../../src/assets/Theme/fonts/glyphicons-halflings-regular.svg
// module chunks = 1